'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats from "./presto.types$-Dashboard-System-Stats.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardSystemStats$() {
}
export { $c_Lpresto_types$DashboardSystemStats$ as $c_Lpresto_types$DashboardSystemStats$ };
$p = $c_Lpresto_types$DashboardSystemStats$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardSystemStats$;
/** @constructor */
function $h_Lpresto_types$DashboardSystemStats$() {
}
export { $h_Lpresto_types$DashboardSystemStats$ as $h_Lpresto_types$DashboardSystemStats$ };
$h_Lpresto_types$DashboardSystemStats$.prototype = $p;
$p.l = (function() {
  return "DashboardSystemStats";
});
$p.cGq = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dSystem$002dStats.$c_Lpresto_types$DashboardSystemStats(x$0.j(0), (x$0.j(1) | 0), x$0.j(2));
});
var $d_Lpresto_types$DashboardSystemStats$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardSystemStats$, "presto.types$DashboardSystemStats$", ({
  Zm: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardSystemStats$ as $d_Lpresto_types$DashboardSystemStats$ };
var $n_Lpresto_types$DashboardSystemStats$;
function $m_Lpresto_types$DashboardSystemStats$() {
  if ((!$n_Lpresto_types$DashboardSystemStats$)) {
    $n_Lpresto_types$DashboardSystemStats$ = new $c_Lpresto_types$DashboardSystemStats$();
  }
  return $n_Lpresto_types$DashboardSystemStats$;
}
export { $m_Lpresto_types$DashboardSystemStats$ as $m_Lpresto_types$DashboardSystemStats$ };
//# sourceMappingURL=presto.types$-Dashboard-System-Stats$.js.map
